var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7692 21L5.53846 21C4.13651 21 3 19.8635 3 18.4615L3 9.23077C3 7.82882 4.13651 6.69231 5.53846 6.69231L6.69231 6.69231L6.69231 5.4066C6.69231 4.07747 7.76978 3 9.0989 3L17.5385 3C19.4502 3 21 4.54978 21 6.46154L21 14.9011C21 16.2302 19.9225 17.3077 18.5934 17.3077L17.3077 17.3077L17.3077 18.4615C17.3077 19.8635 16.1712 21 14.7692 21ZM17.3077 15.9231L18.5934 15.9231C19.1578 15.9231 19.6154 15.4655 19.6154 14.9011L19.6154 6.46154C19.6154 5.31449 18.6855 4.38462 17.5385 4.38462L9.0989 4.38462C8.53448 4.38462 8.07692 4.84217 8.07692 5.4066L8.07692 6.69231L14.7692 6.69231C16.1712 6.69231 17.3077 7.82882 17.3077 9.23077L17.3077 15.9231ZM14.7692 19.6154C15.4065 19.6154 15.9231 19.0988 15.9231 18.4615L15.9231 9.23077C15.9231 8.59352 15.4065 8.07692 14.7692 8.07692L5.53846 8.07693C4.90121 8.07693 4.38461 8.59352 4.38461 9.23077L4.38462 18.4615C4.38462 19.0988 4.90121 19.6154 5.53846 19.6154L14.7692 19.6154Z",
    fill: "#5551ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHover);
export default __webpack_public_path__ + "static/media/copy-hover.42581acb88eda738418a671df513cf56.svg";
export { ForwardRef as ReactComponent };